import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import SubscribedComponent from './subscribed_component.js';

class WreckDetailModal extends SubscribedComponent {
  state = { openModal: false, permissions: [], subscriptionExpirations: {}, claims: {} }

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open && !this.state.openModal) {
      this.setState({
        openModal: true
      })
    }
  }

  toggleModal = () => {
    this.setState({
      openModal: !this.state.openModal
    })
  }

  renderPartialDetails = () => {
    const {
      type, length,
      water_depth: waterDepth,
      year_sunk: yearSunk,
      circumstances_of_loss: CircumstancesOfLoss,
    } = this.props.wreck

    return (
      <ModalBody>
        latitude: <strong>-- Premium Members Only --</strong><br />
        longitude: <strong>-- Premium Members Only --</strong><br />
        <hr />
        Date Sunk: <strong>{yearSunk}</strong><br />
        Type: <strong>{type}</strong><br />
        Length: <strong>{length}</strong><br />
        Max Depth: <strong>{waterDepth}</strong><br />
        Background: <code>{CircumstancesOfLoss}</code>
      </ModalBody>
    )
  }

  renderFullDetails = () => {
    const {
      type, length,
      latitude_display: latitudeDisplay,
      longitude_display: longitudeDisplay,
      water_depth: waterDepth,
      year_sunk: yearSunk,
      circumstances_of_loss: CircumstancesOfLoss,
      surveying_details: SurveyingDetails
    } = this.props.wreck

    return (
      <ModalBody>
        latitude: <strong>{latitudeDisplay}</strong><br />
        longitude: <strong>{longitudeDisplay}</strong><br />
        <hr />
        Date Sunk: <strong>{yearSunk}</strong><br />
        Type: <strong>{type}</strong><br />
        Length: <strong>{length}</strong><br />
        Max Depth: <strong>{waterDepth}</strong><br />
        Background: <code>{CircumstancesOfLoss}</code>
        <hr />
        Updates: <code>{SurveyingDetails}</code>
      </ModalBody>
    )
  }

  render() {
    const {name} = this.props.wreck

    let modalBody
    if (this.hasPermission('wreck_details')) {
      modalBody = this.renderFullDetails()
    } else {
      modalBody = this.renderPartialDetails()
    }

    return (
      <Modal isOpen={this.state.openModal} toggle={this.toggleModal} className={this.props.className}>
        <ModalHeader toggle={this.toggleModal}>{name}</ModalHeader>
        {modalBody}
        <ModalFooter>
          <Button color="secondary" onClick={this.toggleModal}>Close</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default WreckDetailModal;



// WEBPACK FOOTER //
// ./src/components/wreck_detail_modal.js